import React from "react";

const ProjectCard = ({ project, isActive, isPortfolio, onClick }) => {
  if (isPortfolio) {
    return (
      <div
        className={`project-card project-card--all ${isActive ? "active" : ""}`}
        onClick={onClick}
        role="button"
        tabIndex={0}
      >
        <div className="project-card-header">
          <span className="project-card-pill">Portfolio</span>
        </div>

        <h3>All Projects</h3>

        <p>View modules and counts across every assigned project.</p>
      </div>
    );
  }

  return (
    <div
      className={`project-card ${isActive ? "active" : ""}`}
      onClick={onClick}
      role="button"
      tabIndex={0}
    >
      <div className="project-card-header">
        {project.company && (
          <span className="project-card-pill">
            {project.company.slice(0, 26)}
          </span>
        )}
      </div>

      <h3>{project.projectName}</h3>

      {project.siteLocation && (
        <p className="project-meta">{project.siteLocation}</p>
      )}

      {project.projectId && (
        <p className="project-id">Project ID: {project.projectId}</p>
      )}
    </div>
  );
};

export default ProjectCard;
